import { Controller } from "@hotwired/stimulus"

// Mur anti-pub pour les visiteurs à qui l'on sert la pub (le serveur ne rend
// ce contrôleur que pour eux). Si un bloqueur est détecté, un mur bloquant
// s'affiche : le site reste inutilisable tant que le visiteur ne désactive
// pas son bloqueur ou ne paie pas le « sans pub ». Pas d'échappatoire.
//
// Deux signaux, l'un OU l'autre suffit (couvre les deux familles de bloqueurs) :
//  - appât DOM masqué → bloqueur cosmétique (Adblock Plus, règles EasyList) ;
//  - script Monetag (n6wxm.com) injoignable → bloqueur réseau (uBlock Origin,
//    le plus répandu, qui ne masque pas forcément l'appât).
// Risque assumé : une panne du CDN Monetag déclencherait le mur à tort — d'où
// le kill-switch serveur ADS_ENABLED pour tout couper en un instant au besoin.
export default class extends Controller {
  static targets = ["bait", "modal"]
  static values = { loggedIn: Boolean }

  connect() {
    // Laisser à la pub le temps de tenter de se charger avant de juger.
    this._timer = setTimeout(() => this.detect(), 1500)
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
    this.unlockScroll()
  }

  async detect() {
    if (await this.blocked()) this.wall()
  }

  async blocked() {
    return this.baitBlocked() || await this.monetagUnreachable()
  }

  // L'appât : un bloqueur cosmétique le masque (hauteur nulle) ou le retire.
  baitBlocked() {
    const el = this.hasBaitTarget ? this.baitTarget : null
    if (!el) return true
    return el.offsetParent === null || el.offsetHeight === 0 ||
      el.clientHeight === 0 || getComputedStyle(el).display === "none" ||
      getComputedStyle(el).visibility === "hidden"
  }

  // Le script Monetag est servi par n6wxm.com : un bloqueur réseau coupe la
  // requête → le fetch échoue. Sinon (domaine joignable) il résout, même en
  // opaque (mode no-cors).
  async monetagUnreachable() {
    try {
      await fetch("https://n6wxm.com/vignette.min.js", { method: "HEAD", mode: "no-cors", cache: "no-store" })
      return false
    } catch (e) {
      return true
    }
  }

  wall() {
    this.track("shown")
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    this.lockScroll()
    // Re-vérifie périodiquement : si le visiteur désactive son bloqueur sans
    // recharger, le mur se lève tout seul.
    this._watch = setInterval(async () => {
      if (!(await this.blocked())) this.reload()
    }, 2500)
  }

  lockScroll() {
    this._prevOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
  }

  unlockScroll() {
    if (this._watch) clearInterval(this._watch)
    document.body.style.overflow = this._prevOverflow || ""
  }

  reload() {
    this.track("reload")
    this.unlockScroll()
    window.location.reload()
  }

  // Clic sur un CTA du mur (data-adblock-event-param sur le bouton/lien).
  cta(event) {
    this.track(event.params.event)
  }

  // Beacon de mesure du mur : affichages et issues (voir AdblockWallEvent).
  // sendBeacon survit à la navigation/rechargement ; jamais bloquant.
  track(name) {
    try {
      const data = new FormData()
      data.append("event", name)
      navigator.sendBeacon("/track/adblock_wall", data)
    } catch (e) { /* la mesure ne doit jamais casser le mur */ }
  }
}
